import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ChangeDateFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeDateFilter';

    public constructor(public from: Date, public to: Date) {
        super(ChangeDateFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeDateFilter): void => {
    state.filterState.updatedDateFrom = action.from;
    state.filterState.updatedDateTo = action.to;
};

//@ts-ignore
registerReducer(ChangeDateFilter.ACTION_TYPE, reducer);